module.exports = __webpack_public_path__ + "images/homepage-mobile-icon-sideways.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-mobile-icon-sideways.png
// module id = 864
// module chunks = 0